import { render, staticRenderFns } from "./OrganisationUnitItem.vue?vue&type=template&id=7cf5434c&scoped=true&"
import script from "./OrganisationUnitItem.vue?vue&type=script&lang=js&"
export * from "./OrganisationUnitItem.vue?vue&type=script&lang=js&"
import style0 from "./OrganisationUnitItem.vue?vue&type=style&index=0&id=7cf5434c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf5434c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
